import type { VenueRoom as GQLItem } from '../../../generated/api.graphql';
import * as VenueSummary from './VenueSummary';

export type VenueRoom = {
  id: number;
  name: string;
  venue?: VenueSummary.VenueSummary;
};

export const fromGql = (item: GQLItem): VenueRoom => ({
  id: item.id,
  name: item.name,
  venue: item.venue ? VenueSummary.fromGql(item.venue) : undefined,
});
